'use client'

import { useState, useEffect } from 'react'

import TorMatches from 'app/competicio/lligues/[lliga]/[cat]/classificacio/page'
import { useMainContext, useCaptainContext } from 'utils/context'
import { publicGetRequest } from 'services/one'
import { findInObject } from 'utils/objects'
import { ONE } from 'config/apis'
import Title from 'components/privat/Title'
import SelectFilter from 'components/SelectFilter'
import ResultsLeagues from 'components/ResultsLeagues'

const TorMatchesPrivate = () => {
  const { clubId } = useMainContext()
  const { teamFilterSelected, teamSelectedData } = useCaptainContext()
  const [results, setResults] = useState()
  const [dayFilterSelected, setDayFilterSelected] = useState('')
  const [dayFilter, setDayFilter] = useState()
  const [showClubFromPrivate, setShowClubFromPrivate] = useState(false)

  const getFilters = async () => {
    if (teamSelectedData) {
      // setLoading(true)
      if (teamFilterSelected?.IdGroup) {
        const filtersData = await publicGetRequest({
          endpoint: 'LEAGUES_FILTERS',
          id: teamFilterSelected.Sorter
        })
        const matchData = findInObject(
          filtersData.Categories,
          'groupId',
          teamFilterSelected?.IdGroup
        )

        if (matchData) {
          setDayFilterSelected(matchData.matchDays[0].matchDay)
          setDayFilter(
            matchData.matchDays.map(({ matchDay }) => ({
              title: matchDay,
              value: matchDay
            }))
          )
        } else {
          setResults()
        }
      }
      // setLoading(false)
    }
  }
  useEffect(() => {
    getFilters()
  }, [teamFilterSelected])

  useEffect(() => {
    getResults()
  }, [dayFilterSelected])

  const getResults = async () => {
    // setLoading(true)
    const groupId = teamFilterSelected?.IdGroup || teamFilterSelected?.id
    if (dayFilterSelected && groupId) {
      const resultsReq = await fetch(
        ONE.LEAGUES_RESULTS.replace('{id}', groupId).replace(
          '{day}',
          dayFilterSelected
        ),
        {
          ...ONE.HEADERS
        }
      )
      console.log(resultsReq)
      setResults((await resultsReq.json())?.Data?.Results)
    }
  }

  return (
    <>
      <TorMatches
        user={
          teamFilterSelected?.IdGroup || teamFilterSelected?.IdTeam || clubId
        }
        showClubFromPrivate={showClubFromPrivate}
        setShowClubFromPrivate={setShowClubFromPrivate}
      />
      {results && (
        <div className="max-w-6xl mx-3 lg:mx-10 mt-5">
          <Title>Horaris i Resultats</Title>
          <div className="grid grid-cols-1 lg:flex lg:mt-10">
            <SelectFilter
              filters={dayFilter}
              selected={dayFilterSelected}
              setSelected={setDayFilterSelected}
              className="lg:w-[300px] mt-2 lg:mt-0 lg:ml-2"
            />
          </div>
          <div className="mt-5">
            <ResultsLeagues matches={results} showImg={false} />
          </div>
        </div>
      )}
    </>
  )
}

export default TorMatchesPrivate
